// Our JS logic for https://kafkasorganic.com/pages/feeding-guide
// Note: Screens are numbered 0-5, 0 being the loading screen, 1 being the first screen, etc. Naming convention for id is e.g. fg1

// We enclose our code in a function to avoid conflicts
(function(){

  // our constants
  const catPackCalories = 603.366;
  const dogPackCalories = 560.236;
  const gramsPerPack = 454;

  // our managed state
  var state = {
    screen: '#fg0',
    isDog: true,
    name: '',
    age: '',
    months: '',
    weight: '',
    body: '',
    email: '',
    customer_name: '',
    isKgs: false,
    calories: null,
    dailyPacks: null,
    price: null,
    flavours: [],
    feeding_style: null, // 'TOPPER', 'HALF', or 'FULL'
  }

  // Set/change our state, accepts the newstate
  function setState(newState) {
    state = { ...state, ...newState }; // set the state
    // console.log(state);
  }

  // Process our window state so we can handle going back via the browser
  function processWindowState(windowState) {
    if(!windowState) { // If we have no windowstate
      changeScreen('#fg1', false); // Then change to our first screen
    } else { // If we're going back to the last screen
      setState({ ...windowState }); // Update the state
      updateRender();
      changeScreen(windowState.screen, false); // Then change to our new screen
    }
  }

  // When we initially load into the page
  function initialLoad() {
    // unitTests(); // Run our browser unit tests to verify calculators are correct.
    initPageElements(); // initialise our page elements
    if(window.history.state) { // If we retain a state pick up where we left off
      processWindowState(window.history.state);
    } else { // Otherwise start from the start
      changeScreen('#fg1', false); // Then change to our first screen
    }
  }

  // Used for testing the calculators are correct, if you update the formula, make sure to update the asserted values.
  function unitTests() {
    const case1C = getCalories(true, 1, 60, false, 'bodacious');
    const case2C = getCalories(true, 10, 21, false, 'ideal');
    const case3C = getCalories(true, 10, 23, true, 'skinny');
    const case4C = getCalories(false, 10, 23, true, 'skinny');
    const case5C = getCalories(false, 1, 23, false, 'bodacious');
    const case6C = getCalories(false, 10, 92, false, 'bodacious');

    console.assert(case1C === 1670, 'calories test 1 failed.', case1C);
    console.assert(case2C === 532, 'calories test 2 failed.', case2C);
    console.assert(case3C === 1176, 'calories test 3 failed.', case3C);
    console.assert(case4C === 882, 'calories test 4 failed.', case4C);
    console.assert(case5C === 813, 'calories test 5 failed.', case5C);
    console.assert(case6C === 805, 'calories test 6 failed.', case6C);

    const case1P = getPacks(true, case1C);
    const case2P = getPacks(true, case2C);
    const case3P = getPacks(true, case3C);
    const case4P = getPacks(false, case4C);
    const case5P = getPacks(false, case5C);
    const case6P = getPacks(false, case6C);

    console.assert(case1P == 2.74, 'packs test 1 failed.', case1P);
    console.assert(case2P == 0.87, 'packs test 2 failed.', case2P);
    console.assert(case3P == 1.93, 'packs test 3 failed.', case3P);
    console.assert(case4P == 0.93, 'packs test 4 failed.', case4P);
    console.assert(case5P == 0.85, 'packs test 5 failed.', case5P);
    console.assert(case6P == 0.84, 'packs test 6 failed.', case6P);

    const flavours_dog_1 = ['31713792196668', '31713798488124', '31713797832764'];
    const flavours_dog_2 = ['31713792196668', '31713798488124'];

    const flavours_cat_1 = ['31713802125372', '31713810186300', '31713804910652'];
    const flavours_cat_2 = ['31713802125372', '31713810186300'];

    const case1_packsPerFlavour = calculatePacks('FULL', case1P, flavours_dog_1);
    const case2_packsPerFlavour = calculatePacks('HALF', case2P, flavours_dog_1);
    const case3_packsPerFlavour = calculatePacks('FULL', case3P, flavours_dog_2);
    const case4_packsPerFlavour = calculatePacks('FULL', case4P, flavours_cat_1);
    const case5_packsPerFlavour = calculatePacks('HALF', case5P, flavours_cat_1);
    const case6_packsPerFlavour = calculatePacks('FULL', case6P, flavours_cat_2);

    console.assert(case1_packsPerFlavour.join(',') == [8,6,6].join(','), 'priority test 1 failed.', case1_packsPerFlavour);
    console.assert(case2_packsPerFlavour.join(',') == [2,1,1].join(','), 'priority test 2 failed.', case2_packsPerFlavour);
    console.assert(case3_packsPerFlavour.join(',') == [7,7].join(','), 'priority test 3 failed.', case3_packsPerFlavour);
    console.assert(case4_packsPerFlavour.join(',') == [3,2,2].join(','), 'priority test 4 failed.', case4_packsPerFlavour);
    console.assert(case5_packsPerFlavour.join(',') == [1,1,1].join(','), 'priority test 5 failed.', case5_packsPerFlavour);
    console.assert(case6_packsPerFlavour.join(',') == [3,3].join(','), 'priority test 6 failed.', case6_packsPerFlavour);

    const case1_price = getPrice(flavours_dog_1, case1P);
    const case2_price = getPrice(flavours_dog_1, case2P);
    const case3_price = getPrice(flavours_dog_2, case3P);
    const case4_price = getPrice(flavours_cat_1, case4P);
    const case5_price = getPrice(flavours_cat_1, case5P);
    const case6_price = getPrice(flavours_cat_2, case6P);

    console.assert(case1_price.week == 199.8, 'packs test 1 failed.', case1_price);
    console.assert(case2_price.half == 39.96, 'packs test 2 failed.', case2_price);
    console.assert(case3_price.week == 139.86, 'packs test 3 failed.', case3_price);
    console.assert(case4_price.week == 90.93, 'packs test 4 failed.', case4_price);
    console.assert(case5_price.half == 38.97, 'packs test 5 failed.', case5_price);
    console.assert(case6_price.week == 77.94, 'packs test 6 failed.', case6_price);
  }

  // Update the pet's name where it is mentioned.
  function updateName() {
    let name = state.name ? state.name : 'Your Pet';
    let petName = document.querySelectorAll('[data-pet-name]');
    for (var i = 0; i < petName.length; i++) {
      petName[i].textContent = name;
    }
    let petNameRef = document.querySelectorAll('[data-pet-ref]');
    for (var i = 0; i < petNameRef.length; i++) {
      petNameRef[i].textContent = `${name}\'s`;
    }
  }

  // Calculates and returns calories
  function getCalories(isDog = true, ageUnformatted, weightUnformatted, isKgs = false, body) {
    let weight = isKgs ? +weightUnformatted : +weightUnformatted / 2.2;
    let age = +ageUnformatted;
    let calories = 0;

    let base = Math.pow(weight, 3/4); // Calcuate the base of the formulas. This was taken from the original code.
    if(isDog) {
      if(Math.ceil(age) === 1) { // if up to 1 year old
        calories = base*70*2;
      } else if(body === 'bodacious') { // Else if it was set to bodacious
        calories = base*70*0.8;
      } else if(body === 'skinny') { // Else if it was set to skinny
        calories = base*70*1.6;
      } else { // otherwise assume it's ideal
        calories = base*70*1.4;
      }
    } else {
      if(Math.ceil(age) === 1) { // if up to 1 year old
        calories = base*70*2;
      } else if(body === 'bodacious') { // Else if it was set to bodacious
        calories = base*70*0.7;
      } else if(body === 'skinny') { // Else if it was set to skinny
        calories = base*70*1.4;
      } else { // otherwise assume it's ideal
        calories = base*70*1.2;
      }
    }
    return Math.floor(calories); // return the calories value floored.
  }

  // Calculates and returns the daily packs needed
  function getPacks(isDog = true, calories) {
    let dailyPacks = calories / (isDog ? dogPackCalories : catPackCalories);
    return dailyPacks.toFixed(2);
  }

  // Calculates and returns the price points as an object
  function getPrice(flavours, packs) {

    // calculate the packs for each feeding style.
    let packsPerFlavour_FULL = calculatePacks('FULL', packs, flavours);
    let packsPerFlavour_HALF = calculatePacks('HALF', packs, flavours);
    let packsPerFlavour_TOPPER = calculatePacks('TOPPER', packs, flavours);

    // console.log(packsPerFlavour_FULL, packsPerFlavour_HALF, packsPerFlavour_TOPPER);

    // calculate total amount of packs in each options.
    let packsPerFlavour_FULL_TotalPrice = [...packsPerFlavour_FULL].reduce((acc, curr, index) => {
      let newResult = acc;
      let flavourId = flavours[index]; // get the ID of this flavour by the index
      let newPrice = document.querySelector(`#fg3 .option[data-id="${flavourId}"]`) && document.querySelector(`#fg3 .option[data-id="${flavourId}"]`).getAttribute('data-price'); // get the price
      if(!isNaN(newPrice)) { // if our price is a number
        newResult = newResult + (newPrice * curr); // add it to our current total price
      }
      return newResult;
    }, 0);

    let packsPerFlavour_HALF_TotalPrice = [...packsPerFlavour_HALF].reduce((acc, curr, index) => {
      let newResult = acc;
      let flavourId = flavours[index]; // get the ID of this flavour by the index
      let newPrice = document.querySelector(`#fg3 .option[data-id="${flavourId}"]`) && document.querySelector(`#fg3 .option[data-id="${flavourId}"]`).getAttribute('data-price'); // get the price
      if(!isNaN(newPrice)) { // if our price is a number
        newResult = newResult + (newPrice * curr); // add it to our current total price
      }
      return newResult;
    }, 0);

    let packsPerFlavour_TOPPER_TotalPrice = [...packsPerFlavour_TOPPER].reduce((acc, curr, index) => {
      let newResult = acc;
      let flavourId = flavours[index]; // get the ID of this flavour by the index
      let newPrice = document.querySelector(`#fg3 .option[data-id="${flavourId}"]`) && document.querySelector(`#fg3 .option[data-id="${flavourId}"]`).getAttribute('data-price'); // get the price
      if(!isNaN(newPrice)) { // if our price is a number
        newResult = newResult + (newPrice * curr); // add it to our current total price
      }
      return newResult;
    }, 0);

    // console.log(packsPerFlavour_FULL_TotalPrice, packsPerFlavour_HALF_TotalPrice, packsPerFlavour_TOPPER_TotalPrice);

    return {
      week: +packsPerFlavour_FULL_TotalPrice,
      half: +packsPerFlavour_HALF_TotalPrice,
      topper: +packsPerFlavour_TOPPER_TotalPrice
    }

  }


  function calculatePacks(feeding_style, dailyPacks, flavours) {
    // calculate distributing the products among the flavours e.g. 9 packs for 2 would be 5 4
    let packsMultiplier = feeding_style === 'FULL' ? 7 : feeding_style === 'HALF' ? 3.5 : 1.75; // get the packs multiplier
    let packsPerWeek = Math.ceil(packsMultiplier * dailyPacks); // get the total packs per week (rounded up)
    let flavourCount = flavours.length; // The amount of flavours we need to distribute
    let packsPerFlavour = [...flavours].fill(Math.floor(packsPerWeek / flavourCount)); // Fill an array with evenly distributed packs
    let leftover = packsPerWeek % flavourCount; // Our leftover amount of packs after evenly splitting it up.

    if(leftover !== 0) { // if we have any leftover
      let highestPriority = 0;
      let priorityFlavours = [...flavours].reduce((acc, curr) => { // returns an array of the packs with the highest priority
        let newPriorityFlavours = [...acc]; // clone our results array
        let newPriority = document.querySelector(`#fg3 .option[data-id="${curr}"]`) && document.querySelector(`#fg3 .option[data-id="${curr}"]`).getAttribute('data-priority'); // get the priority
        if(!isNaN(newPriority)) { // if our priority is a number
          if(+newPriority === highestPriority) { // if it's equal to our current priority
            newPriorityFlavours.push(curr); // add this id to the results array and return it
            return newPriorityFlavours;
          } else if(+newPriority > highestPriority) { // otherwise if the priority is higher
            highestPriority = +newPriority; // update our highest priority
            return [curr]; // replace the array with a new array containing just this ID.
          }
        }
        return newPriorityFlavours;
      }, []);

      // console.log(priorityFlavours);
      let leftoverDistribution = Math.floor(leftover / priorityFlavours.length); // the equal distribution of leftover packs to priority packs
      let leftoverDistribution_leftovers = leftover % priorityFlavours.length // ...and the leftovers from that

      // loop over the packs, adding our extra even distribution
      for (var i = 0; i < priorityFlavours.length; i++) {
        let flavourIndex = [...flavours].findIndex(x => x === priorityFlavours[i]);
        if(flavourIndex !== -1) { // should never be negative 1...
          packsPerFlavour[flavourIndex] = +packsPerFlavour[flavourIndex] + +leftoverDistribution;
        } else {
          console.log('Warning: flavourIndex is -1');
        }
      }

      // if there's anything left, just add it to the first priority pack or the first pack
      if(leftoverDistribution_leftovers !== 0) {
        let firstIndex = priorityFlavours[0] ? [...flavours].findIndex(x => x === priorityFlavours[0]) : -1;
        if(firstIndex !== -1) {
          packsPerFlavour[firstIndex] = +packsPerFlavour[firstIndex] + +leftoverDistribution_leftovers;
        } else {
          packsPerFlavour[0] = packsPerFlavour[0]+leftoverDistribution_leftovers;
        }
      }
    }
    // console.log(packsPerFlavour);
    return packsPerFlavour;
  }

  // Inputs a decimal and outputs the fraction symbol
  function decimalToFraction(x) {
    let num = +x;
    let leftover = num % 1;
    let baseNum = Math.floor(num).toFixed(0);
    let leftoverNum = '';
    switch (leftover) {
      case (1/4):
        leftoverNum = '¼';
      break;
      case (1/2):
        leftoverNum = '½';
      break;
      case (3/4):
        leftoverNum = '¾';
      break;
      case (1/8):
        leftoverNum = '⅛';
      break;
      case (3/8):
        leftoverNum = '⅜';
      break;
      case (5/8):
        leftoverNum = '⅝';
      break;
      case (7/8):
        leftoverNum = '⅞';
      break;
      case (1/16):
        leftoverNum = '¹⁄₁₆';
      break;
      case (3/16):
        leftoverNum = '³⁄₁₆';
      break;
      case (5/16):
        leftoverNum = '⁵⁄₁₆';
      break;
      case (7/16):
        leftoverNum = '⁷⁄₁₆';
      break;
      case (9/16):
        leftoverNum = '⁹⁄₁₆';
      break;
      case (11/16):
        leftoverNum = '¹¹⁄₁₆';
      break;
      case (13/16):
        leftoverNum = '¹³⁄₁₆';
      break;
      case (15/16):
        leftoverNum = '¹⁵⁄₁₆';
      break;
    }
    return `${baseNum > 0 ? baseNum : ''}${leftoverNum}`;
  }

  // Update the feeding style screen values
  function updateFeedingOptions(packsDaily, priceObject) {
    let topper = document.querySelector('#fg4 [data-option-1]');
    let half = document.querySelector('#fg4 [data-option-2]');
    let full = document.querySelector('#fg4 [data-option-3]');

    // calc the grams
    let halfAmount = ((packsDaily * gramsPerPack) / 2).toFixed(0);
    let quarterAmount = ((packsDaily * gramsPerPack) / 4).toFixed(0);
    let fullAmount = ((packsDaily * gramsPerPack)).toFixed(0);

    document.querySelector('#fg4 [data-option-1] [data-grams]').textContent = `${quarterAmount}g`;
    document.querySelector('#fg4 [data-option-2] [data-grams]').textContent = `${halfAmount}g`;
    document.querySelector('#fg4 [data-option-3] [data-grams]').textContent = `${fullAmount}g`;
  }

  // Update our calories placholders
  function updateCalories(calories) {
    let caloriesElements = document.querySelectorAll('[data-calories]');
    for (var i = 0; i < caloriesElements.length; i++) {
      caloriesElements[i].textContent = calories;
    }
  }

  // Update the flavours we show
  function updateFlavours(isDog = true, reset = true) {
    reset && setState({ flavours: [] }); // Reset the flavours.
    if(isDog) {
      let dogFlavours = document.querySelectorAll('[data-dog-flavour]');
      for (var i = 0; i < dogFlavours.length; i++) {
        dogFlavours[i].setAttribute('data-show', true);
      }
      let catFlavours = document.querySelectorAll('[data-cat-flavour]');
      for (var i = 0; i < catFlavours.length; i++) {
        catFlavours[i].removeAttribute('data-show');
      }
    } else {
      let dogFlavours = document.querySelectorAll('[data-dog-flavour]');
      for (var i = 0; i < dogFlavours.length; i++) {
        dogFlavours[i].removeAttribute('data-show');
      }
      let catFlavours = document.querySelectorAll('[data-cat-flavour]');
      for (var i = 0; i < catFlavours.length; i++) {
        catFlavours[i].setAttribute('data-show', true);
      }
    }
  }

  // Rerenders everything
  function updateRender() {
    // console.log(state);

    // fg1 dog selection
    if(state.isDog) {
      document.querySelector('[data-dog-button]').setAttribute('data-selected', true);
      document.querySelector('[data-cat-button]').removeAttribute('data-selected');
    } else {
      document.querySelector('[data-cat-button]').setAttribute('data-selected', true);
      document.querySelector('[data-dog-button]').removeAttribute('data-selected');
    }

    // fg1 isKgs selection
    if(state.isKgs) {
      document.querySelector('.lbskgs').setAttribute('data-lbs', false);
    } else {
      document.querySelector('.lbskgs').setAttribute('data-lbs', true);
    }

    // fg1 input fields
    document.querySelector('#fg1 input[name="name"]').value = state.name;
    document.querySelector('#fg1 input[name="age"]').value = state.age;
    document.querySelector('#fg1 input[name="months"]').value = state.months;
    document.querySelector('#fg1 input[name="weight"]').value = state.weight;
    document.querySelector('#fg1 select[name="body"]').value = state.body;
    document.querySelector('#fg1 input[name="email"]').value = state.email;
    document.querySelector('#fg1 input[name="customer_name"]').value = state.customer_name;


    // Update the name
    updateName();

    // Update the feeding options
    if(state.dailyPacks && state.price) {
      updateFeedingOptions(state.dailyPacks, state.price);
    }

    // Update the calories
    if(state.calories) {
      updateCalories(state.calories);
    }

    // Update the flavours
    updateFlavours(state.isDog, false);

    // fg3 flavour selection
    let flavourOptions = document.querySelectorAll('#fg3 [data-select-button]');
    for (var i = 0; i < flavourOptions.length; i++) {
      let flv = flavourOptions[i];
      let flvId = flv.getAttribute('data-id');
      if(state.flavours.find(x => x == flvId)) {
        document.querySelector(`#fg3 .option[data-id="${flvId}"]`).setAttribute('data-selected', true);
        flv.textContent = 'Selected';
      } else {
        document.querySelector(`#fg3 .option[data-id="${flvId}"]`).removeAttribute('data-selected');
        flv.textContent = 'Select';
      }
    }

    // fg4 feeding style selection
    if(document.querySelector(`#fg4 .option[data-selected="true"]`)) {
      document.querySelector(`#fg4 .option[data-selected="true"] [data-select-button]`).textContent = 'Select';
      document.querySelector(`#fg4 .option[data-selected="true"]`).removeAttribute('data-selected');
    }
    if(state.feeding_style === 'TOPPER') {
      document.querySelector(`#fg4 [data-option-1]`).setAttribute('data-selected', true);
      document.querySelector(`#fg4 [data-option-1] [data-select-button]`).textContent = 'Selected';
    }
    if(state.feeding_style === 'HALF') {
      document.querySelector(`#fg4 [data-option-2]`).setAttribute('data-selected', true);
      document.querySelector(`#fg4 [data-option-2] [data-select-button]`).textContent = 'Selected';
    }
    if(state.feeding_style === 'FULL') {
      document.querySelector(`#fg4 [data-option-3]`).setAttribute('data-selected', true);
      document.querySelector(`#fg4 [data-option-3] [data-select-button]`).textContent = 'Selected';
    }
  }

  // Inits our page elements, they're all pre-loaded so just need to hook up the event listeners.
  function initPageElements() {

    // back buttons
    let bb = document.querySelectorAll('[data-back-button]');
    for (var i = 0; i < bb.length; i++) {
      bb[i].addEventListener('click', function(e) { // add a click hook to each one
        window.history.back();
      });
    }

    // fg1 dog button
    document.querySelector('[data-dog-button]').addEventListener('click', function() {
      document.querySelector('[data-dog-button]').setAttribute('data-selected', true);
      document.querySelector('[data-cat-button]').removeAttribute('data-selected');
      setState({ isDog: true });
    });

    // fg1 cat button
    document.querySelector('[data-cat-button]').addEventListener('click', function() {
      document.querySelector('[data-cat-button]').setAttribute('data-selected', true);
      document.querySelector('[data-dog-button]').removeAttribute('data-selected');
      setState({ isDog: false });
    });

    // fg1 name input
    document.querySelector('input[name="name"]').addEventListener('input', function(e) {
      setState({ name: e.target.value }); // update our name
      updateName();  // update references to our name
    });

    // fg1 age input
    document.querySelector('input[name="age"]').addEventListener('input', function(e) {
      setState({ age: e.target.value }); // update our age
    });

    // fg1 months input
    document.querySelector('input[name="months"]').addEventListener('input', function(e) {
      setState({ months: e.target.value }); // update our months
    });

    // fg1 weight input
    document.querySelector('input[name="weight"]').addEventListener('input', function(e) {
      setState({ weight: e.target.value }); // update our weight
    });

    // fg1 lbs/kgs toggle
    document.querySelector('.lbskgs').addEventListener('click', function() {
      if(state.isKgs) {
        setState({ isKgs: false });
        document.querySelector('.lbskgs').setAttribute('data-lbs', true);
      } else {
        setState({ isKgs: true });
        document.querySelector('.lbskgs').setAttribute('data-lbs', false);
      }
    });

    // fg1 body input
    document.querySelector('select[name="body"]').addEventListener('input', function(e) {
      setState({ body: e.target.value }); // update our body
    });

    // fg1 customer_name input
    document.querySelector('input[name="customer_name"]').addEventListener('input', function(e) {
      setState({ customer_name: e.target.value }); // update our customer_name
    });

    // fg1 email input
    document.querySelector('input[name="email"]').addEventListener('input', function(e) {
      setState({ email: e.target.value }); // update our email
    });

    // fg1 submit button
    document.querySelector('#fg1 [data-submit-button]').addEventListener('click', function() {

      if(
        state.name &&
        (state.weight || state.weight === 0 || state.weight === "0") && !isNaN(state.weight) &&
        (state.age || state.age === 0 || state.age === "0") && !isNaN(state.age) &&
        state.body &&
        state.email && /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(state.email.trim()) &&
        state.customer_name
      ) {
        document.querySelector('[fg1-error]').removeAttribute('data-show');
        document.querySelector('[fg1-error-1]').removeAttribute('data-show');
        document.querySelector('[fg1-error-2]').removeAttribute('data-show');
        document.querySelector('[fg1-error-3]').removeAttribute('data-show');
        document.querySelector('[fg1-error-4]').removeAttribute('data-show');
        document.querySelector('[fg1-error-5]').removeAttribute('data-show');
        document.querySelector('[fg1-error-6]').removeAttribute('data-show');
        document.querySelector('[fg1-error-7]').removeAttribute('data-show');
        document.querySelector('[fg1-error-8]').removeAttribute('data-show');
        submitFg1();
      } else {
        document.querySelector('[fg1-error]').setAttribute('data-show', true);

        if(!(state.name)) {
          document.querySelector('[fg1-error-1]').setAttribute('data-show', true);
        } else {
          document.querySelector('[fg1-error-1]').removeAttribute('data-show');
        }

        if(!((state.weight || state.weight === 0 || state.weight === "0") && !isNaN(state.weight))) {
          document.querySelector('[fg1-error-3]').setAttribute('data-show', true);
        } else {
          document.querySelector('[fg1-error-3]').removeAttribute('data-show');
        }

        if(!((state.age || state.age === 0 || state.age === "0") && !isNaN(state.age))) {
          document.querySelector('[fg1-error-2]').setAttribute('data-show', true);
        } else {
          document.querySelector('[fg1-error-2]').removeAttribute('data-show');
        }

        if(!(state.body)) {
          document.querySelector('[fg1-error-4]').setAttribute('data-show', true);
        } else {
          document.querySelector('[fg1-error-4]').removeAttribute('data-show');
        }

        if(!(state.customer_name)) {
          document.querySelector('[fg1-error-7]').setAttribute('data-show', true);
        } else {
          document.querySelector('[fg1-error-7]').removeAttribute('data-show');
        }

        if(!(state.email && /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(state.email.trim()))) {
          document.querySelector('[fg1-error-8]').setAttribute('data-show', true);
        } else {
          document.querySelector('[fg1-error-8]').removeAttribute('data-show');
        }

      }
    });

    // dropdowns (currently only on fg3, but the logic is universal)
    let dropdowns = document.querySelectorAll('[data-toggle-dropdown]');
    for (var i = 0; i < dropdowns.length; i++) {
      dropdowns[i].addEventListener('click', function(e) {
        e.currentTarget.toggleAttribute('data-expand')
      });
    }

    // fg3 flavour select buttons
    let flavourOptions = document.querySelectorAll('#fg3 [data-select-button]');
    for (var i = 0; i < flavourOptions.length; i++) {
      flavourOptions[i].addEventListener('click', function(e) {
        let flavourId = e.currentTarget.getAttribute('data-id'); // get the id
        let newFlavours = [...state.flavours]; // Copy the flavours array
        if(newFlavours.find(x => x === flavourId)) { // If the flavour is already in the array, un-select it.
          newFlavours = newFlavours.filter(x => x !== flavourId);
          document.querySelector(`#fg3 .option[data-id="${flavourId}"]`).removeAttribute('data-selected');
          e.currentTarget.textContent = 'Select';
        } else { // Otherwise select it
          newFlavours = [...newFlavours, flavourId];
          document.querySelector(`#fg3 .option[data-id="${flavourId}"]`).setAttribute('data-selected', true);
          e.currentTarget.textContent = 'Selected';
        }

        setState({ flavours: newFlavours }); // Update the flavours state;
      });
    }



    // fg3 submit button
    document.querySelector('#fg3 [data-submit-button]').addEventListener('click', function() {
      if(state.flavours.length){
        document.querySelector('[fg3-error]').removeAttribute('data-show');

        let priceObj = getPrice(state.flavours, state.dailyPacks); // Get our price
        setState({ price: priceObj }); // Update our calories
        updateFeedingOptions(state.dailyPacks, priceObj); // Update the feeding style options

        changeScreen('#fg4')
      } else {
        document.querySelector('[fg3-error]').setAttribute('data-show', true);
      }
    });

    // fg4 option-1 button
    document.querySelector('#fg4 [data-option-1] [data-select-button]').addEventListener('click', function() {
      if(state.feeding_style !== 'TOPPER') {
        if(document.querySelector(`#fg4 .option[data-selected="true"]`)) {
          document.querySelector(`#fg4 .option[data-selected="true"] [data-select-button]`).textContent = 'Select';
          document.querySelector(`#fg4 .option[data-selected="true"]`).removeAttribute('data-selected');
        }
        document.querySelector(`#fg4 [data-option-1]`).setAttribute('data-selected', true);
        document.querySelector(`#fg4 [data-option-1] [data-select-button]`).textContent = 'Selected';
        setState({ feeding_style: 'TOPPER' });
      }
    });

    // fg4 option-2 button
    document.querySelector('#fg4 [data-option-2] [data-select-button]').addEventListener('click', function() {
      if(state.feeding_style !== 'HALF') {
        if(document.querySelector(`#fg4 .option[data-selected="true"]`)) {
          document.querySelector(`#fg4 .option[data-selected="true"] [data-select-button]`).textContent = 'Select';
          document.querySelector(`#fg4 .option[data-selected="true"]`).removeAttribute('data-selected');
        }
        document.querySelector(`#fg4 [data-option-2]`).setAttribute('data-selected', true);
        document.querySelector(`#fg4 [data-option-2] [data-select-button]`).textContent = 'Selected';
        setState({ feeding_style: 'HALF' });
      }
    });

    // fg4 option-3 button
    document.querySelector('#fg4 [data-option-3] [data-select-button]').addEventListener('click', function() {
      if(state.feeding_style !== 'FULL') {
        if(document.querySelector(`#fg4 .option[data-selected="true"]`)) {
          document.querySelector(`#fg4 .option[data-selected="true"] [data-select-button]`).textContent = 'Select';
          document.querySelector(`#fg4 .option[data-selected="true"]`).removeAttribute('data-selected');
        }
        document.querySelector(`#fg4 [data-option-3]`).setAttribute('data-selected', true);
        document.querySelector(`#fg4 [data-option-3] [data-select-button]`).textContent = 'Selected';
        setState({ feeding_style: 'FULL' });
      }
    });

    // fg4 submit button
    document.querySelector('#fg4 [data-submit-button]').addEventListener('click', function() {
      if(state.feeding_style){
        document.querySelector('[fg4-error]').removeAttribute('data-show');
        submitForm(); // submits/finishes the calculator
      } else {
        document.querySelector('[fg4-error]').setAttribute('data-show', true);
      }
    });
  }

  // submits/finishes the calculator
  function submitForm() {
    changeScreen('#fg0', false); // change to the loading screen

    let packsPerFlavour = calculatePacks(state.feeding_style, state.dailyPacks, state.flavours);

    // get our current cart
    $.getJSON('/cart.js', function(cart) {
      // Filter our current cart items to get products that are for the matching pet.
      let oldProducts = [...cart.items].filter( x => (x.properties && x.properties['For']) ? (x.properties['For'] == state.name) : false);

      if(oldProducts.length) { // If we found any

        let updateObj = {};
        for (var i = 0; i < oldProducts.length; i++) {
          updateObj[oldProducts[i].variant_id] = 0;
        }

        $.post( // Update the cart, removing the old surcharge (if applicable), and adding the new one.
          '/cart/update.js',
          {
            updates: updateObj
          },
          function(obj) { // and then add the new products to the cart
            $.post( // Update the cart
              '/cart/add.js',
              {
                items: [...state.flavours].map((x,i) => {
                  return {
                    quantity: +packsPerFlavour[i],
                    id: +x,
                    properties: {
                      'For': `${state.name}`
                    }
                  }
                })
              },
              function(obj) {
                window.location.href = "/cart";
              },
              'json'
            );
          },
          'json'
        );
      } else { // Otherwise just add the packs to the cart
        $.post( // Update the cart
          '/cart/add.js',
          {
            items: [...state.flavours].map((x,i) => {
              return {
                quantity: +packsPerFlavour[i],
                id: +x,
                properties: {
                  'For': `${state.name}`
                }
              }
            })
          },
          function(obj) {
            window.location.href = "/cart";
          },
          'json'
        );
      }
    });
  }



  // Submit screen 1 (info)
  function submitFg1() {
    let calories = getCalories(state.isDog, state.age, state.weight, state.isKgs, state.body); // Calculate our calories
    let packs = getPacks(state.isDog, calories); // Get our packs

    if(window._learnq) {
      _learnq.push(['identify', {
        '$email' : state.email.trim(),
        '$first_name' : state.customer_name.split(' ')[0],
        ...(state.customer_name.split(' ').length > 1) && {'$last_name' : state.customer_name.split(' ')[1]},
        'Pet': state.isDog ? 'Dog' : 'Cat',
        'Weight': state.weight,
        'Unit': state.isKgs ? 'kgs' : 'lbs',
        'Pet Name': state.name,
        'Age (years)': state.age,
        'Age (months)': state.months,
        'Body Condition': state.body,
        'Feeding Calculator' : true,
      }]);
    }

    setState({ calories: calories, dailyPacks: packs }); // Update our calories
    updateCalories(calories); // Update our calories placholders
    updateFlavours(state.isDog); // Update the flavours we show

    changeScreen('#fg3') // Go to the next screen
  }

  // Change our screen - id = id attr of wrapper, history is for whether or not we're navigating to a new "page" for the app that we could want to go back from.
  function changeScreen(id, history = true) {
    history && window.history.replaceState({ ...state }, null); // Update the state of this page
    setState({ screen: id }); // update the screen in our state
    history && window.history.pushState({ ...state }, null); // Push a new state
    document.querySelector('[data-wrapper][data-show="true"]').removeAttribute("data-show");
    document.querySelector(id).setAttribute("data-show", true);
    $("html, body").animate({ scrollTop: document.querySelector('#MainContent').offsetTop }, "slow"); // scroll to the top of the section
  }

  // Our entry point
  $(document).ready(function() {
    window.addEventListener('popstate', e => {
      processWindowState(event.state);
    });
    initialLoad();
  });
})();
